import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { cn } from "@/lib/utils";

export function Stars({ value = 0, size = "h-3.5 w-3.5", testid = "stars" }) {
  if (!value) return null;
  return (
    <span className="inline-flex items-center gap-0.5" data-testid={testid} aria-label={`${value} of 5 stars`}>
      {[1, 2, 3, 4, 5].map((n) => <Star key={n} className={cn(size, n <= value ? "fill-brand-ice text-brand-cyan" : "text-slate-700")} />)}
    </span>
  );
}

export default function StarRating({ jobId, initial = 0 }) {
  const [value, setValue] = useState(initial);
  const [hover, setHover] = useState(0);
  const rate = async (n) => {
    const next = n === value ? 0 : n;
    setValue(next);
    try {
      await api.patch(`/library/${jobId}/rating`, { rating: next });
      toast.success(next ? `Rated ${next} star${next > 1 ? "s" : ""}` : "Rating cleared");
    } catch (e) {
      toast.error(errorMessage(e, "Couldn't save your rating."));
    }
  };
  return (
    <div className="flex items-center gap-1" data-testid="star-rating" data-value={value} onMouseLeave={() => setHover(0)}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onClick={() => rate(n)} onMouseEnter={() => setHover(n)} data-testid={`star-${n}`} data-active={n <= value} aria-label={`Rate ${n} stars`}
          className="flex h-9 w-8 items-center justify-center">
          <Star className={cn("h-5 w-5 transition-colors", n <= (hover || value) ? "fill-brand-ice text-brand-cyan" : "text-slate-600")} />
        </button>
      ))}
    </div>
  );
}
